import script from "./MyOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./MyOrder.vue?vue&type=script&setup=true&lang=js"

import "./MyOrder.vue?vue&type=style&index=0&id=d07d4b98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d07d4b98"]])

export default __exports__